import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BaseListFiltersComponentComponent } from '@shared/components/base-list-filters-component/base-list-filters-component.component';
import { CHIPS_VIEW, ListService } from '@shared/modules/list/services/list.service';
import { TranslateService } from '@ngx-translate/core';
import { Config } from '@shared/configs/config';
import { ContactType } from '@modules/contacts/shared/enums/contact-type.enum';
import { ButtonSize, ButtonTypes } from '@shared/modules/ui/components/button/button.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'project-contacts-filters',
  templateUrl: './project-contacts-filters.component.html'
})
export class ProjectContactsFiltersComponent
  extends BaseListFiltersComponentComponent
  implements OnInit, OnDestroy
{
  Config = Config;
  ButtonSize = ButtonSize;
  ButtonTypes = ButtonTypes;

  contactTypes;

  constructor(
    @Optional() @Inject(CHIPS_VIEW) public chipsView: boolean,
    public service: ListService,
    public t: TranslateService,
    @Optional() private dialogRef: MatDialogRef<ProjectContactsFiltersComponent>
  ) {
    super(service);
  }

  ngOnInit(): void {
    this.createForm();
    this.setContactTypes();

    if (!this.chipsView) {
      this.service.readUrlParams(false);
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  setContactTypes() {
    this.contactTypes = Object.values(ContactType).map((type) => {
      return {
        id: type,
        name: this.t.instant('Contacts.Type.' + type)
      };
    });
  }

  createForm() {
    this.service.filtersForm = new UntypedFormGroup({
      '[function-name][eq]': new UntypedFormControl(null),
      '[a-type][in][]': new UntypedFormControl(null)
    });
  }

  cancel() {
    this.dialogRef.close();
    this.refreshChips();
  }

  submit() {
    this.service.getRows();
    this.dialogRef.close();
    this.refreshChips();
  }
}
